import { Capacitor } from '@capacitor/core'

/**
 * Returns true when running inside a native Capacitor shell (iOS/Android).
 */
export function isNativePlatform() {
  return Capacitor.isNativePlatform()
}

/**
 * Returns the base URL to prepend to API routes.
 *  - Web (dev & prod): '' (relative paths hit the same origin)
 *  - Native (Capacitor): full Vercel URL so requests reach the server
 *
 * Set VITE_API_BASE_URL in .env (or at build time) to your production URL,
 * e.g. VITE_API_BASE_URL=https://unifocus.vercel.app
 */
export function getApiBaseUrl() {
  if (isNativePlatform()) {
    return import.meta.env.VITE_API_BASE_URL || ''
  }
  return ''
}

/**
 * Builds a full API URL from a relative path like '/api/decompose'.
 */
export function apiUrl(path) {
  return `${getApiBaseUrl()}${path}`
}
